<template lang="">
    <div class="">
        <div class="flex gap-2 items-center my-1">

                <input type="month" value="2024-01" v-model="data_inicio" class="text-black text-[16px] border-1 border-[#ccc] p-1 rounded-[5px] w-full">

                <input type="month" value="2024-01" v-model="data_fim" class="text-black text-[16px] border-1 border-[#ccc] p-1 rounded-[5px] w-full">

            </div>

             <div class="flex gap-2 items-center my-1">
                <label class="min-w-[5rem] sm:min-w-[6.5rem]">Cliente:</label>
                <multiselect 
                    v-model="select_cliente" 
                    :options="clientes_filtered" 
                    :multiple="false"
                    :searchable="true"
                    :loading="clientes_loading"
                    :internal-search="false"
                    :clear-on-select="true"
                    :close-on-select="true"
                    :options-limit="50"
                    :limit="50"
                    :limit-text="limitText"
                    :max-height="300"
                    :show-no-results="true"
                    placeholder="Digite para buscar cliente..."
                    label="cliente"
                    track-by="id"
                    @search-change="buscarClientes"
                    class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500">
                    
                    <!-- Template customizado para mostrar nome do cliente -->
                    <template slot="option" slot-scope="props">
                        <div class="option__desc">
                            <span class="option__title">{{ props.option.cliente }}</span>
                            <span v-if="props.option.nif" class="option__small">NIF: {{ props.option.nif }}</span>
                        </div>
                    </template>


                    <template slot="noResult">
                        <span>Nenhum cliente encontrado. Digite para buscar...</span>
                    </template>


                    <template slot="noOptions">
                        <span>Digite pelo menos 3 caracteres para buscar...</span>
                    </template>


                    <template slot="singleLabel" slot-scope="props">
                        <span class="option__desc">
                            <span class="option__title">{{ props.option.cliente }}</span>
                        </span>
                    </template>
        </multiselect>
</div>

<div class="flex gap-2 items-center my-1">
    <label class="min-w-[5rem] sm:min-w-[6.5rem]">Sub-Cliente:</label>

    <select id="subcliente" v-model="select_subcliente"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option value="">Todos os Sub-Clientes</option>
        <option v-for="subcliente in subclientes" :value="subcliente.id">
            {{subcliente.nome}}
        </option>
    </select>
</div>

<div class="flex gap-2 items-center my-1">
    <label class="min-w-[5rem] sm:min-w-[6.5rem]">Local Instalação:</label>
    <multiselect v-model="select_local_instalacao" :options="local_instalacoes" :multiple="false" :searchable="true"
        :loading="local_instalacoes_loading" :internal-search="true" :clear-on-select="true" :close-on-select="true"
        :options-limit="50" :limit="50" :limit-text="limitText" :max-height="300" :show-no-results="true"
        placeholder="Digite para buscar local de instalação..." label="nome" track-by="id"
        
        class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500">

        <template slot="option" slot-scope="props">
                        <div class="option__desc">
                            <span class="option__title">{{ props.option.nome }}</span>
                        </div>
                    </template>

        <template slot="noResult">
                        <span>Nenhum local de instalação encontrado. Digite para buscar...</span>
                    </template>


        <template slot="noOptions">
                        <span>Digite pelo menos 3 caracteres para buscar...</span>
                    </template>


        <template slot="singleLabel" slot-scope="props">
                        <span class="option__desc">
                            <span class="option__title">{{ props.option.local_instalacao }}</span>
                        </span>
                    </template>
    </multiselect>
</div>

<!-- Exclusões: separadas dos filtros de seleção para não se confundirem -->
<!-- Exclusões: separadas dos filtros de seleção para não se confundirem -->
<div class="filtro-exclusao my-2">
    <div class="filtro-exclusao-titulo">
        <i class="fa-solid fa-ban"></i> Excluir da pesquisa
    </div>

    <div class="filtro-exclusao-campo flex gap-2 items-center my-1">
        <label class="min-w-[5rem] sm:min-w-[6.5rem]">Clientes:</label>
        <multiselect
            v-model="select_clientes_excluidos"
            :options="clientes_excluir_filtered"
            :multiple="true"
            :searchable="true"
            :loading="clientes_excluir_loading"
            :internal-search="false"
            :clear-on-select="false"
            :close-on-select="false"
            :preserve-search="true"
            :options-limit="50"
            :limit="50"
            :limit-text="limitText"
            :max-height="300"
            :show-no-results="true"
            :show-labels="false"
            placeholder="Digite para excluir clientes..."
            label="cliente"
            track-by="id"
            @search-change="buscarClientesExcluir"
            class="w-full">

            <template v-slot:option="{ option }">
                <div class="option__desc">
                    <span class="option__title">{{ option.cliente }}</span>
                    <span v-if="option.nif" class="option__small">NIF: {{ option.nif }}</span>
                </div>
            </template>

            <template v-slot:noResult>
                <span>Nenhum cliente encontrado. Digite para buscar...</span>
            </template>

            <template v-slot:noOptions>
                <span>Digite pelo menos 3 caracteres para buscar...</span>
            </template>
        </multiselect>
    </div>

    <div class="filtro-exclusao-campo flex gap-2 items-center my-1">
        <label class="min-w-[5rem] sm:min-w-[6.5rem]">Sub-Clientes:</label>
        <multiselect
            v-model="select_subclientes_excluidos"
            :options="subclientes_excluir_filtered"
            :multiple="true"
            :searchable="true"
            :loading="subclientes_excluir_loading"
            :internal-search="false"
            :clear-on-select="false"
            :close-on-select="false"
            :preserve-search="true"
            :options-limit="50"
            :limit="50"
            :limit-text="limitText"
            :max-height="300"
            :show-no-results="true"
            :show-labels="false"
            placeholder="Digite para excluir sub-clientes..."
            :custom-label="s => s.cliente ? `${s.nome} (${s.cliente})` : s.nome"
            track-by="id"
            @search-change="buscarSubClientesExcluir"
            class="w-full">

            <template v-slot:option="{ option }">
                <div class="option__desc">
                    <span class="option__title">{{ option.nome }}</span>
                    <span v-if="option.cliente" class="option__small">Cliente: {{ option.cliente }}</span>
                </div>
            </template>

            <template v-slot:noResult>
                <span>Nenhum sub-cliente encontrado. Digite para buscar...</span>
            </template>

            <template v-slot:noOptions>
                <span>Digite pelo menos 3 caracteres para buscar...</span>
            </template>
        </multiselect>
    </div>
</div>

<hr class="my-4 border-gray-600">

<div class="flex gap-2 items-center my-1">
    <label class="min-w-[5rem] sm:min-w-[6.5rem]">Familia:</label>
    <multiselect v-model="select_familias" :options="familias" :multiple="true" :close-on-select="false"
        :clear-on-select="false" :preserve-search="true" placeholder="Selecione Famílias (extintor, carretel, ria, etc)" label="nome" track-by="id"
        :preselect-first="false" :show-labels="false" class="w-full">
        <template v-slot:selection="{ values, isOpen }">
            <span class="multiselect__single" v-if="values.length && !isOpen">
                {{ values.length }} família(s) selecionada(s)
            </span>
        </template>
        <template v-slot:noResult>
            <span>Nenhuma família encontrada.</span>
        </template>
        <template v-slot:noOptions>
            <span>Sem famílias disponíveis.</span>
        </template>
    </multiselect>
</div>

<div class="flex gap-2 items-center my-1">
    <label class=" min-w-[5rem] sm:min-w-[6.5rem] ">Distrito:</label>

    <multiselect v-model="select_distritos" :options="distritos" :multiple="true" :close-on-select="false"
        :clear-on-select="false" :preserve-search="true" placeholder="Todos os Distritos" label="distrito" track-by="distrito"
        :show-labels="false" class="w-full">
        <template v-slot:selection="{ values, isOpen }">
            <span class="multiselect__single" v-if="values.length && !isOpen">
                {{ values.length }} distrito(s) selecionado(s)
            </span>
        </template>
        <template v-slot:noResult>
            <span>Nenhum distrito encontrado.</span>
        </template>
        <template v-slot:noOptions>
            <span>Sem distritos disponíveis.</span>
        </template>
    </multiselect>
</div>

<div class="flex gap-2 items-center my-1">
    <label class=" min-w-[5rem] sm:min-w-[6.5rem]">Concelho:</label>
    <multiselect v-model="select_concelhos" :options="concelhos" :multiple="true" :close-on-select="false"
        :clear-on-select="false" :preserve-search="true" placeholder="Todos os Concelhos" label="concelho" track-by="concelho"
        :show-labels="false" class="w-full">
        <template v-slot:selection="{ values, isOpen }">
            <span class="multiselect__single" v-if="values.length && !isOpen">
                {{ values.length }} concelho(s) selecionado(s)
            </span>
        </template>
        <template v-slot:noResult>
            <span>Nenhum concelho encontrado.</span>
        </template>
        <template v-slot:noOptions>
            <span>Selecione primeiro um distrito.</span>
        </template>
    </multiselect>
</div>

<div class="flex gap-2 items-center my-1">
    <label class=" min-w-[5rem] sm:min-w-[6.5rem]">Freguesia:</label>
    <multiselect v-model="select_freguesias" :options="freguesias" :multiple="true" :close-on-select="false"
        :clear-on-select="false" :preserve-search="true" placeholder="Todas as Freguesias" label="freguesia" track-by="freguesia"
        :show-labels="false" class="w-full">
        <template v-slot:selection="{ values, isOpen }">
            <span class="multiselect__single" v-if="values.length && !isOpen">
                {{ values.length }} freguesia(s) selecionada(s)
            </span>
        </template>
        <template v-slot:noResult>
            <span>Nenhuma freguesia encontrada.</span>
        </template>
        <template v-slot:noOptions>
            <span>Selecione primeiro um concelho.</span>
        </template>
    </multiselect>
</div>

<div class="flex gap-2 items-center my-1">
    <label class=" min-w-[5rem] sm:min-w-[6.5rem] text-nowrap">Codigo Postal:</label>
    <input type="text" pattern="^\d{4}-\d{3}$" @input="formatarCodigoPostal" v-model="codigo_postal_concat"
        id="codigo_postal"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
</div>

<div class="flex gap-2 items-center my-1">
    <label class=" min-w-[5rem] sm:min-w-[6.5rem]">Estados:</label>
    <multiselect v-model="select_estados" :options="estados" :multiple="true" :close-on-select="false"
        :clear-on-select="false" :searchable="false" placeholder="Todos os Estados" label="nome" track-by="id"
        :show-labels="false" class="w-full">
        <template v-slot:selection="{ values, isOpen }">
            <span class="multiselect__single" v-if="values.length && !isOpen">
                {{ values.map(v => v.nome).join(', ') }}
            </span>
        </template>
    </multiselect>
</div>

<div class="flex gap-2 items-center my-1">
    <label class=" min-w-[5rem] sm:min-w-[6.5rem]">Zona:</label>
    <multiselect v-model="select_zonas" :options="zona" :multiple="true" :close-on-select="false"
        :clear-on-select="false" :preserve-search="true" placeholder="Todas as Zonas" label="nome" track-by="id"
        :show-labels="false" class="w-full">
        <template v-slot:selection="{ values, isOpen }">
            <span class="multiselect__single" v-if="values.length && !isOpen">
                {{ values.length }} zona(s) selecionada(s)
            </span>
        </template>
        <template v-slot:noResult>
            <span>Nenhuma zona encontrada.</span>
        </template>
        <template v-slot:noOptions>
            <span>Sem zonas disponíveis.</span>
        </template>
    </multiselect>
</div>

<hr class="my-4 border-gray-600">

<div class="flex gap-2 items-center my-1">
    <label class="min-w-[5rem] sm:min-w-[6.5rem]">Ordenar por:</label>
    <select id="ordenacao_campo" v-model="select_ordenacao_campo"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option value="">Sem ordenação</option>
        <option value="valor_previsto">Valor Previsto</option>
        <option value="data_inicio">Data Prevista</option>
        <option value="cliente">Cliente</option>
        <option value="local_instalacao">Instalação</option>
        <option value="qtd_equipamentos">Quantidade Equipamentos - Família</option>
    </select>
</div>

<div class="flex gap-2 items-center my-1">
    <label class="min-w-[5rem] sm:min-w-[6.5rem]">Direção:</label>
    <select id="ordenacao_direcao" v-model="select_ordenacao_direcao"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option value="asc">Ascendente</option>
        <option value="desc">Descendente</option>
    </select>
</div>

<!-- Rodapé fixo no fundo da coluna: Registos e botões ficam sempre visíveis,
     mesmo quando os filtros obrigam a fazer scroll -->
<div class="filtros-rodape flex flex-wrap gap-2 items-center justify-between mt-2 py-2">
    <div class="flex gap-2 items-center">
        <label>Registos:</label>
        <select id="records" v-model=select_records
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-auto p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
            <option value="10" selected>10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
            <option value="">Todos</option>
        </select>
    </div>

    <div class="flex gap-2">
        <AppButton :padding="'var(--padding_btn)'" class="capitalize mb-auto" v-bind:visibility="true" :font_size="12"
            color="#ff9b05" left_icon="fa-solid fa-pen-to-square" text="Confirmar" emitType="select"
            @select="salvar_filtro" />

        <AppButton :padding="'var(--padding_btn)'" class="capitalize mb-auto" v-bind:visibility="true" :font_size="12"
            color="red" left_icon="fa-regular fa-rectangle-xmark" text="Cancelar" emitType="select" @select="close" />
    </div>
</div>
</div>
</template>
<script>

import axios from 'axios';
import AppButton from '@/components/updated/button.vue'
import Dialog from '@/components/dialog/dinamicDialog.vue'
import { toast } from "vue3-toastify";
import Multiselect from 'vue-multiselect'

import 'vue-multiselect/dist/vue-multiselect.css'

export default {
    components: {
        AppButton,
        Dialog,
        Multiselect
    },
    data() {
        return {

            data_inicio: new Date().toISOString().slice(0, 7), // exemplo: "2025-10"
            data_fim: new Date().toISOString().slice(0, 7),

            distritos: [],
            concelhos: [],
            freguesias: [],
            codigos_postais: [],
            familias: [],

            // Escolha múltipla: lista vazia = todos
            select_distritos: [],
            select_concelhos: [],
            select_freguesias: [],
            select_codigos_postais: '',
            select_familias: [],
            select_zonas: [],
            // Contadores para ignorar respostas de pedidos já ultrapassados
            pedido_concelhos: 0,
            pedido_freguesias: 0,
            select_records: '10',
            select_ordenacao_campo: '',
            select_ordenacao_direcao: 'asc',

            select_cliente: null,
            clientes_filtered: [],
            clientes_loading: false,
            clientes_search_timeout: null,

            // Filtro de exclusão: clientes que ficam de fora da pesquisa
            select_clientes_excluidos: [],
            clientes_excluir_filtered: [],
            clientes_excluir_loading: false,
            clientes_excluir_search_timeout: null,

            select_subclientes_excluidos: [],
            subclientes_excluir_filtered: [],
            subclientes_excluir_loading: false,
            subclientes_excluir_search_timeout: null,

            select_subcliente: '',
            subclientes: [],
            subclientes_loading: false,
            subclientes_search_timeout: null,

            subclientes_todos: [],

            select_local_instalacao: '',
            local_instalacoes: [],
            local_instalacoes_loading: false,
            local_instalacoes_search_timeout: null,

            zona: [],

            estados: [
                { id: 'pendente', nome: 'Pendente' },
                { id: 'remarcar', nome: 'Remarcar' },
                { id: 'cancelado', nome: 'Cancelado' },
                { id: 'atribuido', nome: 'Atribuído' },
            ],
            select_estados: [],

            distrito_concat: '',
            concelho_concat: '',
            freguesia_concat: '',
            codigo_postal_concat: '',
            familia_concat: '',
            zona_concat: '',
            currentType: null,
            dialogProps: {
                entity: ['equipamento', 'tpiva', 'tpmoeda'],
                sideBar: true,
                multi: false,
                queryParams: { 'equipamento': 'custom=1&tpmarca_id=1' },
            },
            showDialog: false,
            currentType: '',
            multiSelectOptions: {
                enabled: true,
                show_btn: false
            },

            distritos: [],
            concelhos: [],
            freguesias: [],
            codigos_postais: [],
        }
    },
    methods: {

        // Clientes, subclientes e locais desativados (ou eliminados) não devem
        // aparecer nos filtros: não se planeia sobre eles. Filtra-se pela negativa
        // para que um registo sem 'status' na resposta continue a ser mostrado,
        // em vez de esvaziar a lista toda.
        apenasAtivos(lista) {
            if (!Array.isArray(lista)) return [];
            return lista.filter(item => item && item.status !== 'desativado' && item.status !== 'eliminado');
        },

        buscarClientes(searchQuery) {
            if (searchQuery.length < 3) return;
            // Limpar timeout anterior
            if (this.clientes_search_timeout) {
                clearTimeout(this.clientes_search_timeout);
            }

            // Se busca vazia, limpar resultados
            if (!searchQuery || searchQuery.length < 2) {
                this.clientes_filtered = [];
                return;
            }

            // Debounce de 500ms
            this.clientes_search_timeout = setTimeout(() => {
                this.executarBuscaClientes(searchQuery);
            }, 500);
        },

        async buscarSubClientes(cliente) {
            this.select_local_instalacao = null
            this.local_instalacoes = [];
            this.subclientes = [];
            axios.get(process.env.VUE_APP_URL_BASE + `/api/v1/subcliente/?cliente_id=${cliente.id}`)
                .then(response => {
                    if (response.data.status == 200) {
                        this.subclientes = this.apenasAtivos(response.data.data);
                    } else {
                        toast(response.data.message, {
                            "theme": "auto",
                            "type": "warning",
                            "position": "top-center",
                            "autoClose": 1000,
                        });
                    }
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });

        },

        async executarBuscaClientes(searchQuery) {
            this.select_local_instalacao = null
            this.local_instalacoes = [];
            this.subclientes = [];
            this.clientes_loading = true;


            try {
                const response = await axios.get(`${process.env.VUE_APP_URL_BASE}/api/v1/cliente/s/cliente/${searchQuery}/`);

                if (response.data.status === 200) {
                    this.clientes_filtered = this.apenasAtivos(response.data.data);
                } else {
                    this.clientes_filtered = [];
                    toast("Erro ao buscar clientes", {
                        type: "error",
                        position: "top-center",
                        autoClose: 2000,
                    });
                }
            } catch (error) {
                console.error("Erro ao buscar clientes:", error);
                this.clientes_filtered = [];
                toast("Erro ao buscar clientes", {
                    type: "error",
                    position: "top-center",
                    autoClose: 2000,
                });
            } finally {
                this.clientes_loading = false;
            }
        },

        buscarClientesExcluir(searchQuery) {
            if (this.clientes_excluir_search_timeout) {
                clearTimeout(this.clientes_excluir_search_timeout);
            }

            if (!searchQuery || searchQuery.length < 3) {
                this.clientes_excluir_filtered = [];
                return;
            }

            this.clientes_excluir_search_timeout = setTimeout(() => {
                this.executarBuscaClientesExcluir(searchQuery);
            }, 500);
        },

        // Pesquisa própria: ao contrário do filtro de cliente, não mexe no
        // subcliente/local de instalação nem na seleção já feita.
        async executarBuscaClientesExcluir(searchQuery) {
            this.clientes_excluir_loading = true;

            try {
                const response = await axios.get(`${process.env.VUE_APP_URL_BASE}/api/v1/cliente/s/cliente/${searchQuery}/`);

                if (response.data.status === 200) {
                    // Aqui só se descartam os eliminados: um cliente desativado ainda
                    // pode ter serviços na lista, logo tem de poder ser excluído.
                    this.clientes_excluir_filtered = (response.data.data || [])
                        .filter(item => item && item.status !== 'eliminado');
                } else {
                    this.clientes_excluir_filtered = [];
                    toast("Erro ao buscar clientes", {
                        type: "error",
                        position: "top-center",
                        autoClose: 2000,
                    });
                }
            } catch (error) {
                console.error("Erro ao buscar clientes a excluir:", error);
                this.clientes_excluir_filtered = [];
                toast("Erro ao buscar clientes", {
                    type: "error",
                    position: "top-center",
                    autoClose: 2000,
                });
            } finally {
                this.clientes_excluir_loading = false;
            }
        },

        buscarSubClientesExcluir(searchQuery) {
            if (this.subclientes_excluir_search_timeout) {
                clearTimeout(this.subclientes_excluir_search_timeout);
            }

            if (!searchQuery || searchQuery.length < 3) {
                this.subclientes_excluir_filtered = [];
                return;
            }

            this.subclientes_excluir_search_timeout = setTimeout(() => {
                this.executarBuscaSubClientesExcluir(searchQuery);
            }, 500);
        },

        async executarBuscaSubClientesExcluir(searchQuery) {
            this.subclientes_excluir_loading = true;

            try {
                const response = await axios.get(`${process.env.VUE_APP_URL_BASE}/api/v1/subcliente/pesquisa/`, {
                    params: { q: searchQuery }
                });

                if (response.data.status === 200) {
                    this.subclientes_excluir_filtered = response.data.data || [];
                } else {
                    this.subclientes_excluir_filtered = [];
                }
            } catch (error) {
                console.error("Erro ao buscar sub-clientes a excluir:", error);
                this.subclientes_excluir_filtered = [];
                toast("Erro ao buscar sub-clientes", {
                    type: "error",
                    position: "top-center",
                    autoClose: 2000,
                });
            } finally {
                this.subclientes_excluir_loading = false;
            }
        },

        async buscarLocalInstalacoes(id) {
            this.select_local_instalacao = null;
            this.local_instalacoes = [];
            if (!id) return;

             this.local_instalacoes_loading = true;

            try {
                const response = await axios.get(`${process.env.VUE_APP_URL_BASE}/api/v1/localinstalacao/sub_cliente/${id}/`);

                if (response.data.status === 200) {
                    this.local_instalacoes = this.apenasAtivos(response.data.data);
                } else {
                    this.local_instalacoes = [];
                    toast("Erro ao buscar locais de instalação", {
                        type: "error",
                        position: "top-center",
                        autoClose: 2000,
                    });
                }
            } catch (error) {
                console.error("Erro ao buscar locais de instalação:", error);
                this.local_instalacoes = [];
                toast("Erro ao buscar locais de instalação", {
                    type: "error",
                    position: "top-center",
                    autoClose: 2000,
                });
            } finally {
                this.local_instalacoes_loading = false;
            }
        },


        limitText(count) {
            return `e mais ${count} clientes...`;
        },

        formatarCodigoPostal(event) {
            let valor = event.target.value.replace(/\D/g, ''); // remove tudo que não for número

            if (valor.length > 4) {
                valor = valor.slice(0, 4) + '-' + valor.slice(4, 7);
            }

            event.target.value = valor;
            this.codigo_postal_concat = valor; // mantém o v-model sincronizado
        },
        close() {
            this.select_zonas = [];
            this.select_distritos = [];
            this.select_concelhos = [];
            this.select_freguesias = [];
            this.select_codigos_postais = '';
            this.select_familias = [];
            this.select_cliente = '';
            this.select_clientes_excluidos = [];
            this.clientes_excluir_filtered = [];
            this.select_subclientes_excluidos = [];
            this.subclientes_excluir_filtered = [];
            this.select_subcliente = '';
            this.select_local_instalacao = '';
            this.select_estados = [];
            this.select_records = '10';
            this.select_ordenacao_campo = '';
            this.select_ordenacao_direcao = 'asc';

        },

        salvar_filtro() {

            const final_data = {
                distrito_selecionado: this.select_distritos.map(d => d.distrito),
                concelho_selecionado: this.select_concelhos.map(c => c.concelho),
                freguesia_selecionada: this.select_freguesias.map(f => f.freguesia),
                codigo_postal: this.codigo_postal_concat,
                familias_selecionadas: this.select_familias, // Array de objetos família
                zona_selecionada: this.select_zonas.map(z => z.id), // IDs das zonas
                data_fim: this.data_fim,
                data_inicio: this.data_inicio,
                cliente: this.select_cliente,
                clientes_excluidos: this.select_clientes_excluidos, // where cliente_id not in (...)
                subclientes_excluidos: this.select_subclientes_excluidos, // where subcliente_id not in (...)
                subcliente: this.select_subcliente,
                local_instalacao: this.select_local_instalacao,
                records: this.select_records,
                estado: this.select_estados.map(e => e.id), // vazio = todos
                ordenacao_campo: this.select_ordenacao_campo,
                ordenacao_direcao: this.select_ordenacao_direcao,

                // Para ter os objetos completos também:
                zona_objeto: this.select_zonas,
                total_familias: this.select_familias?.length || 0
            }
            if (final_data) {

                //console.log('Dados selecionados:', final_data);
                this.$emit('confirm', final_data);
            }
        },



        mostrar_distritos() {
            this.distritos = [];
            this.concelhos = [];
            this.freguesias = [];

            axios.get(process.env.VUE_APP_URL_BASE + '/api/v1/distrito_instalacoes/')
                .then(response => {
                    if (response.data.status == 200) {
                        this.distritos = response.data.data;
                    } else {
                        toast(response.data.message, {
                            "theme": "auto",
                            "type": "warning",
                            "position": "top-center",
                            "autoClose": 1000,
                        });
                    }
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });
        },
        // Recarrega os concelhos dos distritos escolhidos e larga os concelhos
        // selecionados que deixaram de pertencer a algum deles.
        mostrar_concelhos(distritos) {
            const pedido = ++this.pedido_concelhos;
            if (!distritos.length) {
                this.concelhos = [];
                this.select_concelhos = [];
                return;
            }
            axios.get(process.env.VUE_APP_URL_BASE + '/api/v1/concelhos/', {
                params: new URLSearchParams(distritos.map(d => ['distrito', d.distrito]))
            }).then(response => {
                if (pedido !== this.pedido_concelhos) return;
                this.concelhos = response.data.status == 200 ? response.data.data : [];
                const nomes = new Set(this.concelhos.map(c => c.concelho));
                this.select_concelhos = this.select_concelhos.filter(c => nomes.has(c.concelho));
                if (response.data.status != 200) {
                    toast(response.data.message, {
                        "theme": "auto",
                        "type": "warning",
                        "position": "top-center",
                        "autoClose": 1000,
                    });
                }
            })
                .catch(error => {
                    console.error("There was an error!", error);
                });
        },
        mostrar_freguesias(concelhos) {
            const pedido = ++this.pedido_freguesias;
            if (!concelhos.length) {
                this.freguesias = [];
                this.select_freguesias = [];
                return;
            }
            axios.get(process.env.VUE_APP_URL_BASE + '/api/v1/freguesias/', {
                params: new URLSearchParams(concelhos.map(c => ['concelho', c.concelho]))
            }).then(response => {
                if (pedido !== this.pedido_freguesias) return;
                this.freguesias = response.data.status == 200 ? response.data.data : [];
                const nomes = new Set(this.freguesias.map(f => f.freguesia));
                this.select_freguesias = this.select_freguesias.filter(f => nomes.has(f.freguesia));
                if (response.data.status != 200) {
                    toast(response.data.message, {
                        "theme": "auto",
                        "type": "warning",
                        "position": "top-center",
                        "autoClose": 1000,
                    });
                }
            })
                .catch(error => {
                    console.error("There was an error!", error);
                });
        },
        mostrar_familias() {
            axios.get(process.env.VUE_APP_URL_BASE + '/api/v1/familia/', {
            }).then(response => {
                if (response.data.status == 200) {
                    this.familias = response.data.data;
                } else {
                    toast(response.data.message, {
                        "theme": "auto",
                        "type": "warning",
                        "position": "top-center",
                        "autoClose": 1000,
                    });
                }
            })
                .catch(error => {
                    console.error("There was an error!", error);
                });
        },
        mostrar_zonas() {
            axios.get(process.env.VUE_APP_URL_BASE + '/api/v1/tpzona/', {
            }).then(response => {
                if (response.data.status == 200) {
                    this.zona = response.data.data;
                } else {
                    toast(response.data.message, {
                        "theme": "auto",
                        "type": "warning",
                        "position": "top-center",
                        "autoClose": 1000,
                    });
                }
            })
                .catch(error => {
                    console.error("There was an error!", error);
                });
        }
    },
    mounted() {
        this.mostrar_distritos();
        this.mostrar_familias();
        this.mostrar_zonas();
    },
    props: {
        data: {
            type: Object,
            default: () => { }
        },
        tecnico: {
            type: Object,
            default: () => { }
        }

    },
    watch: {
        data: {
            handler(val) {
                // Verificar se val existe e não é null/undefined
                if (!val || typeof val !== 'object') {
                    return;
                }

                console.log('Data changed:', val);

                // Verificar cada propriedade individualmente
                if (val.distritos && Array.isArray(val.distritos)) {
                    this.distritos = val.distritos;
                    this.distrito_concat = val.distritos.map(item => item.distrito).join(', ');
                }

                if (val.concelhos && Array.isArray(val.concelhos)) {
                    this.concelhos = val.concelhos;
                    this.concelho_concat = val.concelhos.map(item => item.concelho).join(', ');
                }

                if (val.freguesias && Array.isArray(val.freguesias)) {
                    this.freguesias = val.freguesias;
                    this.freguesia_concat = val.freguesias.map(item => item.freguesia).join(', ');
                }

                if (val.codigos_postais && Array.isArray(val.codigos_postais)) {
                    this.codigos_postais = val.codigos_postais;
                    this.codigo_postal_concat = val.codigos_postais.map(item => item.cp4 + '-' + item.cp3).join(', ');
                }

                if (val.familias && Array.isArray(val.familias)) {
                    this.familias = val.familias;
                    this.familia_concat = val.familias.map(item => item.nome).join(', ');
                }

                if (val.zona && typeof val.zona === 'object') {
                    this.zona = val.zona;
                    this.zona_concat = val.zona.nome || '';
                }

                if (val.data_fim) {
                    this.data_fim = val.data_fim;
                }

                if (val.subclientes && Array.isArray(val.subclientes)) {
                    this.subclientes = this.apenasAtivos(val.subclientes);
                    this.subcliente_concat = this.subclientes.map(item => item.nome).join(', ');
                }


            },
            immediate: true,
            deep: true
        },
        select_distritos(distrito_selecionado) {
            this.mostrar_concelhos(distrito_selecionado);
        },

        select_concelhos(concelho_selecionado) {
            this.mostrar_freguesias(concelho_selecionado);
        },
        select_cliente(cliente_selecionado) {
            // O sub-cliente escolhido pertencia ao cliente anterior
            this.select_subcliente = '';
            if (!cliente_selecionado) {
                this.subclientes = [];
                return;
            }
            this.buscarSubClientes(cliente_selecionado);
        },
        select_subcliente(subcliente_selecionado) {
            this.local_instalacoes = [];
            this.buscarLocalInstalacoes(subcliente_selecionado);
        },
    }

}

</script>
<style>
label {
    color: var(--label);
}

/* Reset dos estilos padrão do multiselect */
.multiselect {
    color: inherit;
    min-height: 42px;
}

.multiselect * {
    box-sizing: border-box;
}

/* Container principal - igual aos selects do Tailwind */
.multiselect__tags {
    min-height: 42px;
    padding: 10px 40px 0 12px;
    border-radius: 0.5rem;
    border: 1px solid #374151;
    background: #374151;
    color: #ffffff;
    font-size: 0.875rem;
    display: block;
    width: 100%;
}

.multiselect__tags:focus-within {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
    border-color: #3b82f6;
}

/* Input de busca */
.multiselect__input {
    background: transparent;
    color: #ffffff;
    font-size: 0.875rem;
    border: none;
    border-radius: 0;
    padding: 0;
    margin-bottom: 8px;
}

.multiselect__input::placeholder {
    color: #9ca3af;
}

/* Placeholder quando não há seleção */
.multiselect__placeholder {
    color: #9ca3af;
    display: inline-block;
    margin-bottom: 10px;
    padding-top: 2px;
    font-size: 0.875rem;
}

/* Tags selecionadas */
.multiselect__tag {
    background: #3b82f6;
    color: white;
    border-radius: 0.25rem;
    padding: 4px 26px 4px 8px;
    margin: 0 8px 8px 0;
    font-size: 0.75rem;
    position: relative;
}

.multiselect__tag-icon {
    cursor: pointer;
    margin-left: 7px;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    font-weight: 700;
    font-style: initial;
    width: 22px;
    text-align: center;
    line-height: 22px;
    transition: all 0.2s ease;
    border-radius: 0.25rem;
    background: #2563eb;
}

.multiselect__tag-icon:after {
    content: "×";
    color: #ffffff;
    font-size: 14px;
}

.multiselect__tag-icon:hover {
    background: #1d4ed8;
}

/* Seta dropdown - igual aos selects */
.multiselect__select {
    height: 40px;
    right: 1px;
    top: 1px;
    padding: 4px 8px;
    margin: 0;
    text-decoration: none;
    text-align: center;
    cursor: pointer;
    transition: transform 0.2s ease;
    background: transparent;
}

.multiselect__select:before {
    position: relative;
    right: 0;
    top: 65%;
    color: #9ca3af;
    margin-top: 4px;
    border-style: solid;
    border-width: 5px 5px 0 5px;
    border-color: #9ca3af transparent transparent transparent;
    content: "";
}

.multiselect--active .multiselect__select:before {
    border-color: transparent transparent #9ca3af transparent;
    border-width: 0 5px 5px 5px;
}

/* Dropdown de opções */
.multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #ffffff;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid #d1d5db;
    border-top: none;
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    z-index: 50;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.multiselect__content {
    list-style: none;
    display: inline-block;
    padding: 0;
    margin: 0;
    min-width: 100%;
    vertical-align: top;
}

/* Opções do dropdown */
.multiselect__element {
    display: block;
}

.multiselect__option {
    display: block;
    padding: 12px;
    min-height: 40px;
    line-height: 16px;
    text-decoration: none;
    text-transform: none;
    vertical-align: middle;
    position: relative;
    cursor: pointer;
    white-space: nowrap;
    color: #374151;
    font-size: 0.875rem;
}

.multiselect__option:after {
    top: 0;
    right: 0;
    position: absolute;
    line-height: 40px;
    padding-right: 12px;
    padding-left: 20px;
    font-size: 13px;
}

/* Opção destacada (hover) */
.multiselect__option--highlight {
    background: #3b82f6;
    outline: none;
    color: white;
}

.multiselect__option--highlight:after {
    content: attr(data-select);
    background: #3b82f6;
    color: white;
}

/* Opção selecionada */
.multiselect__option--selected {
    background: #f3f4f6;
    color: #374151;
    font-weight: 600;
}

.multiselect__option--selected:after {
    content: attr(data-selected);
    color: #10b981;
}

.multiselect__option--selected.multiselect__option--highlight {
    background: #ef4444;
    color: #fff;
}

.multiselect__option--selected.multiselect__option--highlight:after {
    background: #ef4444;
    content: attr(data-deselect);
    color: #fff;
}

/* Estado desabilitado */
.multiselect--disabled {
    opacity: 0.6;
}

.multiselect--disabled .multiselect__select {
    cursor: not-allowed;
}

/* Loading spinner */
.multiselect__spinner {
    position: absolute;
    right: 1px;
    top: 1px;
    width: 40px;
    height: 38px;
    background: #374151;
    display: block;
}

.multiselect__spinner:before,
.multiselect__spinner:after {
    position: absolute;
    content: "";
    top: 50%;
    left: 50%;
    margin: -8px 0 0 -8px;
    width: 16px;
    height: 16px;
    border-radius: 100%;
    border-color: #3b82f6 transparent transparent;
    border-style: solid;
    border-width: 2px;
    animation: spinning 2.4s cubic-bezier(0.41, 0.26, 0.2, 0.62);
    animation-iteration-count: infinite;
}

.multiselect__spinner:before {
    animation-delay: -0.6s;
}

@keyframes spinning {
    from {
        transform: rotate(0);
    }

    to {
        transform: rotate(2turn);
    }
}

/* Responsividade */
@media (max-width: 768px) {
    .multiselect__option {
        padding: 10px 8px;
        font-size: 0.8rem;
    }

    .multiselect__tag {
        font-size: 0.7rem;
        padding: 3px 22px 3px 6px;
    }
}

/* Estilos para os templates customizados do cliente */
.option__desc {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
}

.option__title {
    font-weight: 600;
    font-size: 0.875rem;
    color: #374151;
}

.multiselect__option--highlight .option__title {
    color: white;
}

.option__small {
    font-size: 0.75rem;
    color: #6b7280;
    margin-top: 2px;
}

.multiselect__option--highlight .option__small {
    color: #e5e7eb;
}

/* Melhorar o loading state */
.multiselect--loading .multiselect__placeholder {
    color: #9ca3af;
}

.multiselect--loading .multiselect__input {
    background-color: #f9fafb;
}

.multiselect__single {
    background-color: transparent;
}

/* Secção de exclusões: destacada a vermelho para não se confundir com seleção */
.filtro-exclusao {
    border: 1px solid var(--glass-red);
    border-left-width: 4px;
    border-radius: var(--glass-radius);
    padding: 0.25rem 0.5rem;
}

.filtro-exclusao-titulo {
    color: var(--glass-red);
    font-weight: 600;
    font-size: 0.75rem;
    line-height: 1.2;
}

/* Fica colado ao fundo da coluna com scroll (overflow-y-auto no pai) */
.filtros-rodape {
    position: sticky;
    bottom: 0;
    z-index: 10;
    background: var(--fundoForm);
    border-top: 1px solid var(--glass-border);
}

/* O campo tem de poder encolher: sem min-width: 0 a tag mais comprida
   alarga o multiselect para fora do painel */
.filtro-exclusao-campo .multiselect {
    flex: 1 1 0;
    min-width: 0;
}

.filtro-exclusao .multiselect__tag {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: top;
}

.filtro-exclusao .multiselect__option {
    white-space: normal;
}

.filtro-exclusao .multiselect__tag,
.filtro-exclusao .multiselect__tag-icon,
.filtro-exclusao .multiselect__tag-icon:hover {
    background: var(--glass-red);
}
</style>